module.exports = __webpack_public_path__ + "593a3d53/img/pdf-icon.79f04a36.svg";